import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { DecimalPlaceEnum } from 'src/app/domain/registration/enums/decimal-place.enum';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { TypeQuestionEventsEnum } from 'src/app/domain/registration/enums/type-question-events.enum';
import { TypesEventsEnum } from 'src/app/domain/registration/enums/types-events.enum';


export const COLUMNS_TO_SELECT = ['code', 'actions'];
export const RELATIVE_URL = 'form-responses';
export const COLUMNS_TO_SHOW_WEB = [
  'image',
  'code',
  'formDescription',
  'typeQuestion', 
  'name',
  'email',
  'createdAt',
  'actions'
];
export const COLUMNS_TO_SHOW_MOBILE = ['code', 'name','typeQuestion','question', 'actions'];
export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'code',
    display: 'CÓDIGO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE}`,
  },
  {
    link_show: true,
    field_type: FieldTypeEnum.IMAGE,
    property: 'image',
    display: 'IMAGEM',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} image-size`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'typeEvent',
    display: 'TIPO DE EVENTO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'typeQuestion',
    display: 'TIPO DE PERGUNTA',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'formDescription',
    display: 'NOME EVENTO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'name',
    display: 'NOME',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'email',
    display: 'EMAIL',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'Filter',
    display: 'FILTRAR',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE}`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'question',
    display: 'PERGUNTA',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'answers',
    display: 'RESPOSTA',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'responses',
    display: 'RESPOSTAS',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE}`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'createdAt',
    display: 'CRIADO EM',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
];

export const CES_CONFIG_FIELDS = [
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'CÓDIGO',
    name: 'code',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'EMAIL',
    name: 'EMAIL',
    placeholder: 'Insira uma descrição',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    labelSave: 'Salvar',
    labelCancel: 'Cancelar',
    name: 'cancelSave',
    type: TypeComponentFieldEnum.CANCEL_SAVE,
  },
];

export const filterFields: IFieldConfig[] = [
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'DESCRIÇÃO',
    name: 'description',
    placeholder: 'Insira a descrição',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO DE EVENTO',
    name: 'typeEvent',
    options: ['TODOS', ...Object.values(TypesEventsEnum)],
    placeholder: 'Selecione uma opção',
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO DE FORMULÁRIO',
    name: 'typeQuestion',
    options: ['TODOS', ...Object.values(TypeQuestionEventsEnum)],
    placeholder: 'Selecione uma opção',
  },
];

